(($, Drupal, drupalSettings) => {

  var SelectionHandler = function(group) {
    this.el = group;
    this.init();
  }

  SelectionHandler.prototype = {
    sel: [
      'region',
      'service',
      'language'
    ],
    init: function() {

      const _updateView = (e) => {

        const _clean = (prefix) => {
          return (this[prefix].value !== 'all' ? prefix + '=' + this[prefix].value : '');
        }

        const _createUrl = () => {
          return '?' + this.sel.map(i => _clean(i)).filter(el => el != '').join('&');
        }

        const search = _createUrl();

        var langCode = '/'+drupalSettings.path.currentLanguage;
        langCode = (langCode == '/fi') ? '' : langCode;

        Drupal.ajax({
          url: langCode+'/view_offices/ajax/' + search + '&path=' + drupalSettings.path.currentPath,
        }).execute().done( () => {
          if (history.pushState) {
            let doneSearch = _createUrl();

            window.history.pushState({ path: doneSearch }, '', search);

            if(typeof e.detail != "undefined") {
              e.detail.callback();
            }

            if(doneSearch != search) {
              _updateView(e);
            }
          }
        });

        if (history.pushState) {
          window.history.pushState({ path: search }, '', search);
        }
        SelectionHandler.findNearestOffice = false;
      }

      const selectAndBind = sel => {
        var el = this.el.querySelector(sel);
        el.addEventListener('change', _updateView.bind(this));
        return el;
      }

      this.sel.forEach(i => this[i] = selectAndBind('.' + i + '-select'));

      var el = this.el.querySelector('.locate');

      if (el) {
        // We do have location on our browser
        if (navigator.geolocation) {

          // Calculate distance on sphere
          const distance = (lat1, lon1, lat2, lon2) => {
            var p = 0.017453292519943295; // Math.PI / 180
            var c = Math.cos;
            var a = 0.5 - c((lat2 - lat1) * p) / 2 +
              c(lat1 * p) * c(lat2 * p) *
              (1 - c((lon2 - lon1) * p)) / 2;

            return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
          }

          // Callback to location query
          const matchLocationBasedOffices = pos => {
            const { latitude, longitude } = pos.coords;
            const view = document.querySelectorAll('.view-display-id-list_all_the_offices');
            if (!view) return;
            const offices = view[0].querySelectorAll('.view-content article.node');
            if (!offices) return;

            var officeList = [];

            // Hide offfices without location data.
            offices.forEach(item => {
              if (!item.dataset.locationInformation) {
                item.style.display = 'none';
              }
            });

            // group handling
            const checkIfGroupIsEmpty = (groups, parent) => {

              // Groups sorting
              const groupShortest = (a) => {
                var Shortest = 99999;
                var tmpArr = [];
                var shortestA, shortestB;
                a.querySelectorAll('.views-row article').forEach(node => tmpArr.push(node));

                // Just to make shorter the code
                const getDistance = (el) => {
                  if (!el.dataset.locationInformation) {
                    return 9999;
                  }

                  var b = JSON.parse(el.dataset.locationInformation);
                  return distance(parseFloat(b[0]), parseFloat(b[1]), latitude, longitude);
                }

                // Sort array and get shortest to var
                tmpArr.sort((a, b) => {
                  shortestA = getDistance(a);
                  shortestB = getDistance(b);

                  Shortest = (Shortest > shortestA || Shortest > shortestB) ? (shortestA < shortestB ? shortestA : shortestB) : Shortest;

                  return shortestA - shortestB;
                });

                // helper to loop till we found certain parent with class.
                const findParent = (el, parentClass) => {
                  var loopEl = el;
                  var founded = loopEl.classList.contains(parentClass);

                  while (!founded && loopEl != document) {
                    loopEl = loopEl.parentElement;
                    founded = loopEl.classList.contains(parentClass);
                  }

                  return loopEl;
                }

                // And rearrange elements.
                tmpArr.forEach(item => {
                  var parent = findParent(item, 'views-row');

                  parent.parentElement.appendChild(parent);
                })

                return Shortest;
              }

              // short groups to nearest first
              var emptyGroup, toArrayConversion = [];
              var aShortestDistance = 0,
                  bShortestDistance = 0;

              groups.forEach(group => toArrayConversion.push(group));
              toArrayConversion.sort((a, b) => {

                aShortestDistance = groupShortest(a);
                bShortestDistance = groupShortest(b);

                return aShortestDistance - bShortestDistance;
              });

              // re arrange groups.
              toArrayConversion.forEach((item,index) => {
                emptyGroup = true;
                item.querySelectorAll('article.node').forEach( node => {
                  if(emptyGroup) {
                    emptyGroup = node.style.display === 'none';
                  }
                })

                // Show only first 5
                if(emptyGroup || index > 5){
                  item.style.display = 'none';
                }
                parent.appendChild(item);
              })
            }
            checkIfGroupIsEmpty(view[0].querySelectorAll('.grouped'), view[0].querySelectorAll('.view-content')[1]);
            view[0].classList.remove('loading');
          }

          el.addEventListener('click', e => {
            const view = document.querySelectorAll('.view-display-id-list_all_the_offices');
            if (view) {
              // Reset region value and trigger change.
              var select = document.querySelector('.region-select');
              if(select.value != 'all') {
                select.value = 'all';
                select.dispatchEvent(new CustomEvent('change', {
                  detail: {
                    callback: () => navigator.geolocation.getCurrentPosition(matchLocationBasedOffices)
                  }
                }));
              }
              else {
                navigator.geolocation.getCurrentPosition(matchLocationBasedOffices);
              }

              view[0].classList.add('loading');

              $([document.documentElement, document.body]).animate({
                scrollTop: $(view[0]).offset().top
              }, 350);
            }

          })

        }
      }
    }
  }

  Drupal.behaviors.office_listings = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('.office-filters')).once().each((index, filterGroup) => {
      $(once('office-filters', '.office-filters')).each((index, filterGroup) => {
        new SelectionHandler(filterGroup);
      })
    }
  }


})(jQuery, Drupal, drupalSettings);
